import { createAction, props } from '@ngrx/store';

import { FraudOutcome } from '../../reducers/fraud-detector-simulator/fraud-detector-simulator.reducer';

export const UpdateFraudDetectorSimulatorLevel = createAction(
  '[Fraud Detector Mock] Update Fraud Detector Success',
  props<{ level: FraudOutcome }>(),
);
